export default __webpack_public_path__ + "static/example_image-dd549003dbaa305bb29ca523687be14b.png";